export const PDF_SAFE_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
];

const PDF_SAFE_IMAGE_MIME_SET = new Set(
  PDF_SAFE_IMAGE_MIME_TYPES.map((mime) => mime.toLowerCase()),
);

const PDF_SAFE_IMAGE_EXTENSIONS: Array<string> = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
];

const hasPdfSafeImageExtension = (fileName: string) =>
  PDF_SAFE_IMAGE_EXTENSIONS.some((ext) => fileName.toLowerCase().endsWith(ext));

export default function isPdfSafeImageFile(file: File) {
  const type = file.type.toLowerCase();
  if (type !== '' && PDF_SAFE_IMAGE_MIME_SET.has(type)) {
    return true;
  }
  if (type === '' || type === 'application/octet-stream') {
    return hasPdfSafeImageExtension(file.name);
  }
  return false;
}
